var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAddBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    stroke: "#500D76",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.20325 12.8293C2.53871 12.8293 2 12.2906 2 11.626V3.20325C2 2.53871 2.53871 2 3.20325 2H11.626C12.2906 2 12.8293 2.53871 12.8293 3.20325V9.21951L9.82114 6.21138L3.20325 12.8293ZM3.20325 12.8293H8.9187M12.8293 11.0244V12.8293M12.8293 12.8293V14.3333M12.8293 12.8293H11.0244M12.8293 12.8293H14.6341M6.21138 5.30894C6.21138 5.80735 5.80735 6.21138 5.30894 6.21138C4.81054 6.21138 4.4065 5.80735 4.4065 5.30894C4.4065 4.81054 4.81054 4.4065 5.30894 4.4065C5.80735 4.4065 6.21138 4.81054 6.21138 5.30894Z",
    stroke: "{stroke}",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddBg);
export default __webpack_public_path__ + "static/media/icAddBg.da4711cd8b5521a25e1b2d36a809e82e.svg";
export { ForwardRef as ReactComponent };